import { render, staticRenderFns } from "./TagBadge.vue?vue&type=template&id=ee09324a&scoped=true"
import script from "./TagBadge.vue?vue&type=script&lang=js"
export * from "./TagBadge.vue?vue&type=script&lang=js"
import style0 from "./TagBadge.vue?vue&type=style&index=0&id=ee09324a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee09324a",
  null
  
)

export default component.exports